import { sharedID } from 'blocks/SocketProvider/constants';
import { DerivativeInvokeEnum, DerivativeSocketConfigType } from 'views/derivatives/types';

const baseConfig = (invokeType: DerivativeInvokeEnum, symbol: string): DerivativeSocketConfigType => ({
  hub: 'hubs/shared',
  invokeType,
  subscribeId: sharedID,
  data: [[symbol]],
  id: symbol,
});

export const subscribeConfig = (symbol: string): DerivativeSocketConfigType => ({
  ...baseConfig(DerivativeInvokeEnum.SUBSCRIBE_DERIVATIVE, symbol),
  hubEvents: [DerivativeInvokeEnum.RECEIVE_DERIVATIVE_PRICE, DerivativeInvokeEnum.RECEIVE_DERIVATIVE_MARK_PRICE],
});

export const unsubscribeConfig = (symbol: string): DerivativeSocketConfigType => ({
  ...baseConfig(DerivativeInvokeEnum.UNSUBSCRIBE_DERIVATIVE, symbol),
});

export default { subscribeConfig, unsubscribeConfig };
